import { useEffect } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { GhostLink } from 'chime-ui/components/Button';
import { colors } from 'chime-ui/system';

import { privacyNoticeText } from 'consts/termsOfServiceConsts';

import {
  bancorpPrivacyPolicyLink,
  chimePrivacyPolicyLink,
  stridePrivacyPolicyLink,
} from 'utils/linkHelper';
import { trackPrivacyPolicyLinkPresented } from 'utils/segment/trackingEvents';

import ResponsiveBottomSheet, {
  ResponsiveBottomSheetButton,
} from './ResponsiveBottomSheet';

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.5rem;
  color: ${colors['content-primary']};
`;

const BottomSheetDescription = styled.div`
  overflow-y: auto;
  max-height: 50vh;
`;

const TextBlock = styled.small`
  align-self: center;
  color: ${colors['content-secondary']};
  display: block;
  font-size: 0.75rem;
  font-weight: 450;
  line-height: 1rem;
  margin-bottom: 1rem;
`;

const bottomSheetTitle = 'Legal disclosures';

const DisclosureModalBottomSheet = ({ closeBottomSheet }) => {
  const currentYear = new Date().getFullYear();
  useEffect(() => {
    trackPrivacyPolicyLinkPresented(bottomSheetTitle);
  }, []);

  return (
    <ResponsiveBottomSheet closeBottomSheet={closeBottomSheet}>
      <Title>{bottomSheetTitle}</Title>
      <BottomSheetDescription>
        <TextBlock>
          {`By entering your personal information, you are providing this data to The Bancorp Bank, N.A., or Stride Bank N.A. and Chime for their own separate uses as described in their Privacy Notices and your personal information may be shared between these parties, including for marketing, as legally permitted. Please review `}
          <GhostLink href={bancorpPrivacyPolicyLink} target="_blank">
            The Bancorp Bank, N.A.’s {privacyNoticeText}
          </GhostLink>
          {', '}
          <GhostLink href={stridePrivacyPolicyLink} target="_blank">
            Stride Bank N.A. {privacyNoticeText}
          </GhostLink>
          {', and '}
          <GhostLink href={chimePrivacyPolicyLink} target="_blank">
            Chime’s U.S. Privacy Notice
          </GhostLink>
          .
        </TextBlock>
        <TextBlock>
          IMPORTANT INFORMATION ABOUT PROCEDURES FOR OPENING A NEW ACCOUNT: To
          help the government fight the funding of terrorism and money
          laundering activities, federal law requires all financial institutions
          to obtain, verify, and record information that identifies each person
          who opens an Account. What this means for you: When you open an
          Account, we will ask for your name, address, date of birth, and other
          information that will allow us to identify you. We may also ask to see
          a copy of your driver’s license or other identifying documents.
        </TextBlock>
        <TextBlock>
          Chime is a financial technology company, not an FDIC-insured bank.
          Banking services provided by The Bancorp Bank, N.A., or Stride Bank,
          N.A., Members FDIC. Deposit insurance covers the failure of an insured
          bank. Certain conditions must be satisfied for pass-through deposit
          insurance coverage to apply.
        </TextBlock>
        <TextBlock>{`©${currentYear} Chime. All Rights Reserved.`}</TextBlock>
      </BottomSheetDescription>
      <ResponsiveBottomSheetButton onClick={closeBottomSheet}>
        Close
      </ResponsiveBottomSheetButton>
    </ResponsiveBottomSheet>
  );
};

DisclosureModalBottomSheet.propTypes = {
  closeBottomSheet: PropTypes.func.isRequired,
};

export default DisclosureModalBottomSheet;
